$(document).ready(function() {   
// Home banner slider
$('.home_slider').slick({
        dots: false,
        fade:true,
        infinite: true,
        arrows:false, 
        autoplay: false,
         adaptiveHeight: true,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1
    });
  $('a[href="#"]').attr('href', 'javascript:void(0)');  


  $('.text-slider').slick({
	  dots: false,
	  infinite: true,
	  arrow:false,
	  speed:15000,
	  centerMode: false,
	  slidesToShow:1,
		variableWidth: true,
	  slidesToScroll: 1,
	  cssEase: 'linear',
	  autoplay: true,
	  autoplaySpeed: 0,
	  responsive: [
		{
		  breakpoint: 991,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		  }
		},
		{
		  breakpoint: 767,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		  }
		}
	   ]
});



  
});



